"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var react_player_1 = __importDefault(require("react-player"));
var TileWrapper_1 = require("./TileWrapper");
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    .react-player {\n        video {\n            object-fit: cover;\n            width: 100%;\n            height: 100%;\n        }\n    }\n"], ["\n    width: 100%;\n    height: 100%;\n    .react-player {\n        video {\n            object-fit: cover;\n            width: 100%;\n            height: 100%;\n        }\n    }\n"])));
var getId = function (youtubeUrl) {
    var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var match = youtubeUrl.match(regExp);
    return (match && match[2].length === 11)
        ? match[2]
        : null;
};
var VideoFrame = styled_components_1["default"].iframe(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n"], ["\n    width: 100%;\n    height: 100%;\n"])));
exports.VideoTile = function (props) {
    var blok = props.blok;
    var _a = react_1.useState(false), playing = _a[0], setPlaying = _a[1];
    return (react_1["default"].createElement(TileWrapper_1.TileWrapper, { noPseudoElement: true, width: [1, 1 / 2] },
        react_1["default"].createElement(Wrapper, { onClick: function () { return setPlaying(!playing); } },
            react_1["default"].createElement(react_player_1["default"], { className: "react-player", width: "100%", height: "100%", controls: true, playing: playing, light: blok.Thumbnail && blok.Thumbnail.filename, url: blok.Video.url, style: { objectFit: "cover" } }))));
};
var templateObject_1, templateObject_2;
